import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Financial Module Service Stores
 */
export const financialStores: ServiceStoreConfig[] = [
  // Accounts Payable
  {
    name: "ap-invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "ap-payments",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "nacha-files",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "vendor-ach-info",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "vendor-default-gl",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "vendors",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Accounts Receivable
  {
    name: "ar-invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "ar-payments",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "ar-deposits",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "ica-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "payment-entities",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Check Printing & Templates
  {
    name: "check-templates",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "check-template-elements",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "check-print-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Asset Transactions
  {
    name: "asset-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Task Workflow & Approvals
  {
    name: "approval-queue",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "workflow-rules",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "task-history",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Freight Matching
  {
    name: "freight-matching-groups",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Fiscal Periods
  {
    name: "fiscal-periods",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "closed-period-adjustments",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // General Ledger & Journal
  {
    name: "gl-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Job Costing
  {
    name: "job-cost-allocations",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // WIP & Form Costing
  {
    name: "wip-entries",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "form-inventory",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Audit
  {
    name: "audit-log",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Recurring Transactions
  {
    name: "recurring-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "recurring-transaction-instances",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Payroll Integration
  {
    name: "everee-worker-data",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.invoicesStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalInvoices = entities.length;
          const unpaidInvoices = entities.filter(
            (invoice: Record<string, unknown>) =>
              invoice.status === "unpaid" || invoice.status === "pending",
          ).length;
          const overdueInvoices = entities.filter(
            (invoice: Record<string, unknown>) => {
              const dueDate = new Date(invoice.dueDate as string);
              return dueDate < new Date() && invoice.status !== "paid";
            },
          ).length;
          const totalAmount = entities.reduce(
            (sum: number, invoice: Record<string, unknown>) => {
              return (
                sum +
                ((invoice.amount as number) || (invoice.total as number) || 0)
              );
            },
            0,
          );

          return [
            {
              title: "Total Invoices",
              value: () => totalInvoices.toString(),
              valueColor: "primary.main",
              onClick: () => {
                console.log("Navigate to failed inspections list");
              },
            },
            {
              title: "Unpaid",
              value: () => unpaidInvoices.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Overdue",
              value: () => overdueInvoices.toString(),
              valueColor: "error.main",
            },
            {
              title: "Total Amount",
              value: () => `$${((totalAmount as number) / 1000).toFixed(0)}K`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "bills",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "payments",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "tax-rates",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "chart-of-accounts",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "journal-entries",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "financial-reports",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
  // New backend services - change orders
  {
    name: "change-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "change-order-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "change-order-attachments",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Purchase order approvals support service
  {
    name: "purchase-order-approvals",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Phase 2: Manufacturing Costing Services
  {
    name: "job",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "cost-allocations",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "inventory-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "inventory-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "wip-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "cost-allocation-rules",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Phase 3: Production Cost Tracking Services
  {
    name: "production-costs",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "labor-entries",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "equipment-costs",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "cost-variances",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "standard-costs",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Phase 5: Automation & Integration Services
  {
    name: "automation-workflows",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "workflow-executions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "shipping-invoice-rules",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "qc-inspections",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "qc-inspection-results",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "qc-certificates",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "batch-processes",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "batch-process-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "recurring-invoices",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "month-end-closes",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "month-end-close-steps",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "auto-posting-rules",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Phase 6: Advanced Features Services
  // Multi-Entity Management
  {
    name: "legal-entities",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "intercompany-transactions",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "consolidated-financials",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Audit Trail
  {
    name: "audit-logs",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "audit-reports",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "data-migration-logs",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // Compliance
  {
    name: "compliance-reports",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "compliance-rules",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "compliance-violations",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "document-retention-policies",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "retained-documents",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "compliance-certifications",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
];
